import React, {useRef, useState} from "react";
import {ChevronLeftIcon} from "@heroicons/react/solid";
import {useNavigate, useLocation} from "react-router-dom";
import {useDispatch} from "react-redux";
import {postLogIn, sendMfa} from "../redux/actions/authSlice";
import {toast} from "react-toastify";
import {createGuid} from "../utils/createUid";
import {OtpInput} from "reactjs-otp-input";

const TrustDeviceCheckbox = ({isChecked, setIsChecked}) => {
  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };

  return (
    <div className="flex items-center ">
      <label
        htmlFor="trust-device-checkbox"
        className="inline-flex items-center cursor-pointer"
      >
        <span className="relative">
          <span
            className={`block w-5 h-5 rounded border ${
              isChecked ? "border-gray-400] bg-[#822433]" : "border-gray-300"
            } transition duration-200`}
          >
            {" "}
          </span>
          {/* {isChecked && (
            <span className="absolute block w-4 h-4 top-1 left-1 bg-[#822433] rounded transform transition duration-200"></span>
          )} */}
        </span>
        <input
          id="trust-device-checkbox"
          name="trust-device-checkbox"
          type="checkbox"
          className="sr-only"
          checked={isChecked}
          onChange={handleCheckboxChange}
        />
        <span
          className={`ml-2 text-sm mt-[2px] ${
            isChecked ? "text-[#822433]" : "text-gray-500"
          }`}
        >
          Trust this device for the next 14 days
        </span>
      </label>
    </div>
  );
};

const MfaInput = () => {
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const inputsRef = useRef([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  let location = useLocation();
  const handleCodeChange = (code) => {
    setCode(code);
  };
  const handleBackClick = () => {
    navigate("/");
  };
  let data = location.state.data ? location.state.data : "Error";
  const handleSubmit = async () => {
    if (isChecked) {
      // Generate a random number
      const randomNumber = createGuid();
      // Store the random number and the expiry date in Local Storage
      localStorage.setItem(
        "wiseberry.trustedDevice.key",
        JSON.stringify({
          value: randomNumber,
          expiry: Date.now() + 14 * 24 * 60 * 60 * 1000, // 14 days in milliseconds
          // expiry: Date.now() + 120000, //2mins
        })
      );
    }
    const trustedDeviceKey =
      localStorage.getItem("wiseberry.trustedDevice.key") || null;
    let keyValue = JSON.parse(trustedDeviceKey);
    let obj = {...data};
    if (data?.mfa_code === null) {
      obj.mfa_code = code;
    }

    if (data?.trustedDevice === null && isChecked) {
      obj.trustedDevice = keyValue.value;
      obj.trust_this_device = true;
    }
    setLoading(true);
    // debugger;
    // Now you can use the code for verification
    try {
      const result = await dispatch(postLogIn(obj));
      if (result.meta.requestStatus === "fulfilled") {
        setLoading(false);
        // navigate("/mfa");
        navigate("/dashboard", {state: {data: obj}});
      }
    } catch (error) {
      toast.error(error.response?.data?.data);
    } finally {
      setLoading(false);
    }
  };

  const resendMfa = async () => {
    // debugger;
    try {
      const result = await dispatch(sendMfa(data));
      if (result.meta.requestStatus === "fulfilled") {
        // setLoading(false);
        // navigate("/mfa");
        // navigate("/dashboard", {state: {data: obj}});
      }
      toast.success("Code resent successfully");
    } catch (error) {
      toast.error(error.response?.data?.data);
    } finally {
      // setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center  mx-5 relative">
      <div className="absolute left-0  top-0">
        <button
          onClick={handleBackClick}
          className=" mt-3  mx-0 flex items-center px-2 py-1 rounded-full space-x-2 hover:bg-[#822433] focus:outline-none focus:ring-2 focus:bg-[#822433] focus:ring-opacity-50"
        >
          <ChevronLeftIcon className="bg-white text-primary-wiseberry w-10 h-10 rounded-full " />
        </button>
      </div>

      {data === "Error" ? (
        <div className="text-red-500 w-full flex justify-center items-center text-sm flex-col">
          <p className="text-center">
            {" "}
            Something went wrong. Please go back and log in again.
          </p>
          <button
            className="pb-3 text-sm font-openSans mx-3 text-gray-800 mt-3"
            onClick={() => handleBackClick()}
          >
            Go back
          </button>
        </div>
      ) : (
        <div className=" max-w-md w-full space-y-5 px-2 py-3 bg-[#fff] rounded-xl shadow-lg text-gray-700 xl:px-5">
          <div>
            <h2 className="mt-6 text-center text-3xl font-extrabold font-menu tracking-tighter text-primary-wiseberry">
              Enter Your MFA Code
            </h2>
          </div>
          <div className="flex justify-center items-center  ">
            <OtpInput
              value={code}
              isInputNum
              onChange={handleCodeChange}
              numInputs={6}
              inputStyle={{
                background: "#f6f6f6",
                color: "#822433",
                borderRadius: "5px",
                border: "1px solid #6B7280",
                width: "50px",
                height: "50px",
                margin: "1px",
                fontSize: "20px",
                textAlign: "center",
                outline: "none",
                ring: "2px #822433 solid",
                ringOffset: "1px",
              }}
            />
          </div>
          <div className="flex justify-center w-[95%] sm:w-[75%]  mx-auto flex-col space-y-4 ">
            <button
              className={`group relative w-full mx-auto flex justify-center py-2 px-4 border border-gray-500 text-sm  rounded-md text-white bg-[#822433] hover:bg-[#822433] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#822433] cursor-pointer  hover:text-white  font-openSans font-extrabold ${
                loading ? "cursor-not-allowed" : ""
              }`}
              disabled={loading}
              onClick={() => handleSubmit()}
            >
              {loading ? "Verifying..." : "Verify"}
            </button>
            <TrustDeviceCheckbox
              isChecked={isChecked}
              setIsChecked={setIsChecked}
            />
            <button
              className="pb-3 text-sm font-openSans  text-[#822433] text-start"
              onClick={() => resendMfa()}
            >
              Resend code?{" "}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default MfaInput;
